<div class="w3-large" style="float: right;">
    <a (click)="Cancel()">
        <mat-icon>close</mat-icon>
    </a>
</div>


<h1 mat-dialog-title i18n="Formula Details header | Headline of the formula details component"><b>{{data.name}}</b>

    {{'FORMULA_DETAILS_COMPONENT.TAB_HEADERS.CORRECTIVE_ACTION_PLAN'| translate}}
</h1>

<form [formGroup]='correctiveActionPlan' id='formCAP' #CAPForm="ngForm">

    <div class="flex flex-row">

        <mat-form-field class='capQuestions'>
            <mat-label>{{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.REMEDIATION" | translate}}</mat-label>
            <mat-select matNativeControl formControlName="remediation" (selectionChange)="onRemidationChange($event)">
                <mat-option value="STeP Declaration Letter">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.OPTIONS.SELF_DECLARATION" | translate}}
                </mat-option>


                <mat-option value="Add CAS Number(s)">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.OPTIONS.ADD_CAS_NO" | translate}}
                </mat-option>


                <mat-option value="Stop">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.OPTIONS.STOP" | translate}}
                </mat-option>
                <mat-option value="Substitute">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.OPTIONS.SUBSTITUTE" | translate}}
                </mat-option>
                <mat-option value="Update">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.OPTIONS.UPDATE" | translate}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="this.correctiveActionPlan.controls['remediation'].invalid">
                {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.ERROR_STATES.MISSING_REMEDIATION_PLAN" | translate}}
            </mat-error>
        </mat-form-field>
        <br>
        <mat-form-field class='ml-4  capQuestions'
            *ngIf="this.correctiveActionPlan.controls['remediation'].value === 'Substitute'">
            <mat-label>{{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.CHEMICAL_NAME" | translate}}</mat-label>
            <input matInput formControlName="substituteChemical">
            <mat-error *ngIf="this.correctiveActionPlan.controls['substituteChemical'].invalid">
                {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.ERROR_STATES.MISSING_SUBSTITUTED_CHEMICAL" |
                translate}}{{data['name']}}</mat-error>
        </mat-form-field>

        <mat-form-field class='ml-4  capQuestions'
            *ngIf="this.correctiveActionPlan.controls['remediation'].value === 'Update'">
            <mat-label>{{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.ACTION" | translate}}</mat-label>
            <mat-select matNativeControl formControlName="action">
                <mat-option value="Test">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.UPDATE_OPTIONS.TEST" | translate}}
                </mat-option>
                <mat-option value="Certify">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.UPDATE_OPTIONS.CERTIFY" | translate}}
                </mat-option>
                <mat-option value="Contact Chemical Supplier">
                    {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.UPDATE_OPTIONS.CONTACT_CHEMICAL_SUPPLIER" |
                    translate}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="this.correctiveActionPlan.controls['action'].invalid">
                {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.ERROR_STATES.MISSING_ACTION" | translate}}
            </mat-error>
        </mat-form-field>
        <br>
        <mat-form-field class='ml-4 capQuestions'>
            <mat-label>{{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.DEADLINE" | translate}}</mat-label>
            <input matInput [min]="this.dateToday" formControlName="deadline" [matDatepicker]="datePicker">
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker startView="year"></mat-datepicker>
            <mat-error *ngIf="this.correctiveActionPlan.controls['deadline'].invalid">
                {{"FORMULA_DETAILS_COMPONENT.CORRECTIVE_ACTION_PLAN.ERROR_STATES.MISSING_DEADLINE" | translate}}
            </mat-error>
        </mat-form-field>
        <br>
        <mat-form-field class='ml-4  capQuestions'>
            <mat-label>CAP Status</mat-label>
            <mat-select matNativeControl formControlName="cap_status">
                <mat-option [value]=1>
                    Resolved
                </mat-option>

                <mat-option [value]=0>
                    Pending
                </mat-option>
            </mat-select>

        </mat-form-field>
    </div>
</form>


<div *ngIf="isSelfDeclaration && isSelfDeclarationUploaded">
    {{"SDS_DOCUMENT_UPLOAD_COMPONENT.SELF_DECLARATION_UPLOADED_NOTE"|
    translate}}
</div>
<app-shared-document-upload *ngIf="isSelfDeclaration && !isSelfDeclarationUploaded" [data]="uploadData"
    (onUploadEvent)="onUploadEvent($event)" [selfDeclarationUpload]="true"></app-shared-document-upload>

<div *ngIf="isAddCASNo">
    <table>
        <tr>
            <th style="width: 40%;">
                {{"SDS_DOCUMENT_UPLOAD_COMPONENT.NAME"| translate}}
            </th>
            <th style="width: 20%;">
                {{"SDS_DOCUMENT_UPLOAD_COMPONENT.CAS_NO"|
                translate}}
            </th>
            <th style="width: 20%;">
                {{"SDS_DOCUMENT_UPLOAD_COMPONENT.CONCENTRATION"|
                translate}}
            </th>
            <th style="width: 10%;">
                {{"SDS_DOCUMENT_UPLOAD_COMPONENT.ACTION"|
                translate}}
            </th>
        </tr>
        <tr *ngFor="let sub of hazardousSubstances;let z = index">
            <td>
                <input class="small-input" [(ngModel)]="sub.substanceName">
            </td>
            <td>
                <input class="small-input sm:w-24 " [(ngModel)]="sub.casNo"    pattern="^\d{2,7}[-]\d{2}[-]\d{1}\s*"  #SubCAS="ngModel" required>
                <br>
                <small style="color: red;" *ngIf="SubCAS.errors?.pattern">
                    Invalid CAS Number
                    <br>( Remove extra whitespaces, if any )
                </small>
            </td>
            <td>
                <input class="small-input  sm:w-24" [(ngModel)]="sub.concentration">
            </td>

            <td>
                <!-- <mat-icon>edit</mat-icon> -->
                <div class="flex flex-row">
                    <mat-icon (click)="deleteHazardSubstance( z,sub)">
                        delete
                    </mat-icon>
                    &nbsp;

                    <mat-icon *ngIf="(hazardousSubstances.length-1)==z" (click)="addNewHazardousSubstance('','','')">
                        add
                    </mat-icon>
                </div>

            </td>
        </tr>
    </table>

</div>


<!-- <span *ngIf="isSelfDeclarationUploaded">

    {{"FORMULA_DETAILS_COMPONENT.FORMULA_DETAILS.SELF_DECLARATION_UPLOADED" |
    translate}}
</span> -->
<!-- <div *ngIf="!isSelfDeclaration || isSelfDeclarationUploaded "  -->
<div mat-dialog-actions class="mb-1" i18n="Formula Details Save and Cancel Buttons">
    <button mat-button mat-raised-button form="formCAP" [disabled]="data.readonly"
        (click)="Save(data);CAPForm.ngSubmit.emit()"
        class="ml-4 btn btn-primary">{{"FORMULA_DETAILS_COMPONENT.FORMULA_DETAILS.SAVE_BUTTON" |
        translate}}</button>

    <button mat-button mat-raised-button class="ml-4"
        (click)="Cancel()">{{"FORMULA_DETAILS_COMPONENT.FORMULA_DETAILS.CANCEL_BUTTON"
        | translate}}</button>
</div>